import React from 'react';
import { Message, Icon, Container} from 'semantic-ui-react';
import { Route } from 'react-router';

import AuthContainer from '../components/AuthContainer.js'


export function usrObjMaker(authData) {
  //extracting required data for user object before handing to Root app
  let { uid, displayName, photoURL, email } = authData;
  let usrObj = { uid, displayName, photoURL, email };

  return usrObj;
}

export function renderLoadingMsg(headline = 'Loading...', content = 'We are fetching the data for you.') {
  return (
    <Container text>
      <Message compact color='blue' icon>
        <Icon name='circle notched' loading color='black'/>
        <Message.Content>
          <Message.Header>
            {headline}
          </Message.Header>
          {content}
        </Message.Content>
      </Message>
    </Container>
  );
}

export const RouteWhenAuthed = ({component: Component, ...rest}) => {
  const { user } = {...rest};
  return (
    <Route {...rest} render={(props) =>
        (Boolean(user) === true)
        ? <Component {...rest} />
        : <AuthContainer warningMessage {...props} />} />
  )
};

export function buildObjectsArr(nestedObject) {
  const result = Object.keys(nestedObject)
    .map(key => {
      let obj = nestedObject[key];
      obj['key'] = key;
      return obj;
    });
  return result;
}

export function flatten(arr) {
  arr.reduce((acc, val) => acc.concat(Array.isArray(val)
    ? flatten(val)
    : val), [])
}



// WEBPACK FOOTER //
// ./src/helper/helper.js